<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <vx-card>
            <div class="row">
              <div class="col-md-12 text-right">
                <vs-button to="/tarifs/add">{{ $t('addTariff') }}</vs-button>
              </div>
              <vs-table
                stripe
                search
                :data="$store.state.tariffs"
                class="w-full ml-3 mr-3"
                maxHeight="1000px"
              >
                <template slot="header">
                  <h3>{{ $t('tariffs') }}</h3>
                </template>
                <template slot="thead">
                  <vs-th class="colors width">{{$t("controller")}}</vs-th>
            
                  <vs-th class="colors" sort-key="tariffName">{{$t("tariffName")}}</vs-th>
                  <vs-th class="colors" sort-key="value">{{$t("value")}}</vs-th>
                  <vs-th class="colors" sort-key="price">{{$t("price")}}</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr class="tr" :key="indextr" v-for="(item, indextr) in data">
                    <vs-td :data="item.id">
                      <ActionButton
                        :id="item.id"
                        :tariffName="item.tariffName"
                        :description="item.description"
                        :value="item.value"
                        :price="item.price"
                        :active="item.active"
                        @refresh="getTarrifs"
                      ></ActionButton>
                    </vs-td>
         
                    <vs-td :data="item.tariffName">{{ item.tariffName }}</vs-td>
                    <vs-td :data="item.value">{{ item.value }}</vs-td>
                    <vs-td :data="item.price">{{ formatPrice(item.price) }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "./Buttons/ActionsButton";
import http from "../../../http/http-helper";

export default {
  components: {
    ActionButton
  },
  data() {
    return {
      tariffs: []
    };
  },
  methods: {
    getTarrifs() {
      this.$vs.loading();
      let path = "/tariffs/getlist";
      http.get(path).then(response => {
        this.tariffs = response;
        this.$store.state.tariffs = this.tariffs;
        this.$vs.loading.close();
      });
    },
     formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  created() {
    this.getTarrifs();
  }
};
</script>

<style scoped>
.colors {
  background-color: rgb(218, 216, 216) !important;
}

.width {
  width: 110px !important;
}
</style>